import { getQueryVariable } from "utils";
import { removeLocalStorage } from "utils/storage";
import { restartWebsocket } from "../config";

export default ({ data, functions }) => {
  const botId = getQueryVariable("botId", document.location.search);
  const { dispatch } = functions;
  const origin = getQueryVariable("origin", document.location.search);
  const {
    webchatKey,
    scriptConfig: { web },
  } = data;

  removeLocalStorage(botId, webchatKey);
  dispatch(
    restartWebsocket({
      dataToWebsocket: {
        id: botId,
        origin,
        webchatKey,
        web,
      },
      dataToResetConversation: {},
      forceReset: true,
    })
  );
};
